import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinthane() {



    const cardData = {
"keyword": "Cab Service in Thane",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Cab Service in Thane for travelers looking for safe, affordable, and convenient local as well as outstation transportation solutions. Whether you need airport transfers, daily office commuting, railway station pickups, business travel, family trips, sightseeing tours, wedding transportation, or long-distance journeys, our taxi service ensures a smooth and stress-free travel experience across Thane and nearby cities. With experienced drivers familiar with Thane city roads, Mumbai traffic routes, highways, and nearby travel destinations, clean air-conditioned vehicles maintained for maximum comfort, and transparent pricing with no hidden charges, we provide a dependable cab booking solution for every passenger. Our fleet includes sedans, SUVs, Innova cars, Ertiga vehicles, tempo travellers, and premium cars suitable for solo travelers, families, corporate clients, and group travel requirements.",

"topPlaces": [
  
  {
    "title": "Mahabaleshwar",
    "description": "Famous hill station in Maharashtra known for strawberries, viewpoints, and cool climate."
  },
  {
    "title": "Goa",
    "description": "India’s top beach destination famous for nightlife, beaches, water sports, and Portuguese heritage."
  },
  {
    "title": "Nashik",
    "description": "Religious and wine capital of India known for Trimbakeshwar Temple and vineyards."
  },
  {
    "title": "Shirdi",
    "description": "Holy pilgrimage town dedicated to Sai Baba attracting millions of devotees every year."
  },
  {
    "title": "Lonavala",
    "description": "Popular hill station near Mumbai known for Bhushi Dam, green valleys, waterfalls, and weekend trips."
  },
  {
    "title": "Pune",
    "description": "Cultural and educational hub known for forts, IT parks, and pleasant weather."
  },
  {
    "title": "Aurangabad",
    "description": "Historic city famous for Ajanta & Ellora Caves, UNESCO World Heritage sites."
  },
  {
    "title": "Alibaug",
    "description": "Coastal town near Mumbai known for beaches, resorts, and weekend getaways."
  },
  {
    "title": "Kolhapur",
    "description": "Cultural city famous for Mahalaxmi Temple, Kolhapuri cuisine, and history."
  },
  {
    "title": "Ratnagiri",
    "description": "Scenic Konkan coastal destination known for beaches, mangoes, and forts."
  }
],



services: [
  {
    name: "Cabs in Thane",
    description: "Cabs in Thane service provides reliable transportation for travelers planning comfortable local and outstation road journeys. Vehicles ensure smooth city and highway travel suitable for airport transfers, tourism trips, family vacations, and executive travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Thane. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Thane to Pune Cab",
    description: "Thane to Pune cab service provides dependable transportation for travelers planning smooth road journeys between Thane and Pune. Vehicles ensure reliable highway travel suitable for business trips, tourism travel, airport transfers, and family vacations. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Thane. Flexible booking options allow convenient Pune cab reservations."
  },
  {
    name: "Cab Booking in Thane",
    description: "Cab booking in Thane service provides quick and convenient transportation reservations for travelers planning comfortable road journeys. Vehicles ensure smooth city and highway travel suitable for tourism trips, airport transfers, executive travel, and family outings. Professional chauffeurs ensure dependable pickup and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Thane. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Cab Service in Thane",
    description: "Cab service in Thane offers reliable transportation solutions for travelers seeking smooth and safe local and outstation road travel. Comfortable vehicles ensure dependable city and highway journeys suitable for tourism trips, airport transfers, family vacations, and executive travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Thane. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Ertiga on Rent in Thane",
    description: "Ertiga on rent in Thane service provides spacious and comfortable transportation for travelers planning local and outstation road journeys. Ertiga vehicles ensure reliable city and highway travel suitable for airport transfers, family travel, tourism trips, and executive journeys. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Thane. Flexible booking options allow convenient Ertiga rental reservations."
  },
  {
    name: "Innova Car on Rent in Thane",
    description: "Innova car on rent in Thane service offers spacious transportation with comfortable vehicles suitable for smooth road journeys. Innova vehicles ensure reliable highway and city travel ideal for tourism trips, family vacations, airport transfers, and executive travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport areas across Thane. Flexible booking options allow convenient Innova rental reservations."
  },
  {
    name: "Innova on Rent in Thane",
    description: "Innova on rent in Thane service provides dependable transportation for travelers planning spacious and comfortable road journeys. Innova vehicles ensure smooth city and highway travel suitable for tourism travel, airport transfers, family holidays, and executive trips. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Thane. Flexible booking options allow convenient Innova rental reservations."
  },
  {
    name: "Taxi Services in Thane",
    description: "Taxi services in Thane provide reliable transportation for travelers planning comfortable local and outstation road journeys. Vehicles ensure smooth city and highway travel suitable for airport transfers, tourism trips, executive travel, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Thane. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Thane Cabs",
    description: "Thane cabs service offers dependable transportation solutions for travelers planning smooth local and intercity road travel. Comfortable vehicles ensure reliable city and highway journeys suitable for tourism trips, airport transfers, family travel, and executive journeys. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Thane. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Outstation Cab Service Thane",
    description: "Outstation cab service Thane provides reliable long-distance transportation for travelers planning comfortable intercity road journeys. Vehicles ensure smooth highway travel suitable for tourism trips, family vacations, pilgrimage tours, and executive travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport areas across Thane. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Thane Airport Cab Service",
    description: "Thane airport cab service provides direct airport transportation for travelers planning smooth pickup and drop road journeys. Vehicles ensure reliable city and highway travel suitable for airport transfers, tourism travel, executive trips, and family holidays. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby areas across Thane. Flexible booking options allow convenient airport cab reservations."
  },
  {
    name: "Tourist Taxi Service Thane",
    description: "Tourist taxi service Thane offers comfortable transportation for travelers planning sightseeing tours and holiday road journeys. Vehicles ensure smooth city and highway travel suitable for tourism trips, family vacations, beach tours, and hill station travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from hotels, homes, railway stations, airports, and nearby tourist areas across Thane. Flexible booking options allow convenient tourist taxi reservations."
  },
  {
    name: "Best Cab Service in Thane",
    description: "Best cab service in Thane provides premium transportation with comfortable vehicles and experienced chauffeurs for smooth road journeys. Vehicles ensure reliable city and highway travel suitable for airport transfers, executive travel, tourism trips, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Thane. Flexible booking options allow convenient premium cab reservations."
  },
  {
    name: "Cheap Taxi Service Thane",
    description: "Cheap taxi service Thane offers budget-friendly transportation for travelers planning economical local and outstation road journeys. Comfortable vehicles ensure smooth city and highway travel suitable for tourism trips, airport transfers, and family outings. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport areas across Thane. Flexible booking options allow convenient low-cost taxi reservations."
  },
  {
    name: "Online Cab Booking Thane",
    description: "Online cab booking Thane service provides quick and convenient transportation reservations for travelers planning comfortable road journeys. Vehicles ensure reliable city and highway travel suitable for tourism travel, airport transfers, executive trips, and family vacations. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Thane. Flexible online booking options allow convenient cab reservations."
  },
  {
    name: "Thane Cab Fare",
    description: "Thane cab fare service provides affordable and transparent transportation pricing for travelers planning smooth local and outstation road journeys. Comfortable vehicles ensure dependable city and highway travel suitable for tourism travel, airport transfers, and family outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport areas across Thane. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Thane Taxi Fare",
    description: "Thane taxi fare service offers economical transportation pricing for travelers planning comfortable city and intercity road journeys. Vehicles ensure reliable city and highway travel suitable for tourism trips, executive travel, airport transfers, and family holidays. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Thane. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "24x7 Cab Service Thane",
    description: "24x7 cab service Thane provides round-the-clock transportation for travelers requiring flexible and reliable road travel services. Vehicles ensure smooth city and highway travel suitable for airport transfers, emergency travel, tourism trips, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available anytime from homes, hotels, offices, railway stations, and nearby airport areas across Thane. Flexible booking options allow convenient 24x7 cab reservations."
  },
  {
    name: "Reliable Taxi Service Thane",
    description: "Reliable taxi service Thane provides dependable transportation for travelers planning safe and smooth local and outstation road journeys. Comfortable vehicles ensure reliable city and highway travel suitable for tourism trips, airport transfers, executive travel, and family holidays. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Thane. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Affordable Cab Booking Thane",
    description: "Affordable cab booking Thane service offers economical transportation reservations for travelers planning budget-friendly road journeys. Vehicles ensure smooth city and highway travel suitable for tourism travel, airport transfers, family outings, and executive trips. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Thane. Flexible booking options allow convenient affordable cab reservations."
  },
  {
    name: "Premium Cab Service Thane",
    description: "Premium cab service Thane provides luxury transportation with spacious and comfortable vehicles for smooth road journeys. Vehicles ensure reliable city and highway travel suitable for executive travel, airport transfers, tourism trips, and family vacations. Professional chauffeurs ensure dependable pickup and premium transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Thane. Flexible booking options allow convenient premium cab reservations."
  },
  {
    name: "Trusted Thane Cabs",
    description: "Trusted Thane cabs service provides dependable transportation solutions for travelers planning safe and comfortable road journeys. Comfortable vehicles ensure smooth city and highway travel suitable for airport transfers, tourism travel, executive trips, and family holidays. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Thane. Flexible booking options allow convenient trusted cab reservations."
  },
  {
    name: "Thane to Goa Cab",
    description: "Thane to Goa cab service provides comfortable transportation for travelers planning long-distance road journeys to Goa. Vehicles ensure smooth highway travel suitable for beach holidays, tourism travel, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Thane. Flexible booking options allow convenient Goa cab reservations."
  },
  {
    name: "Thane to Lonavala Cab",
    description: "Thane to Lonavala cab service provides reliable transportation for travelers planning hill station road journeys from Thane. Vehicles ensure smooth highway and ghat travel suitable for tourism trips, sightseeing tours, and family outings. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Thane. Flexible booking options allow convenient Lonavala cab reservations."
  },
  {
    name: "Thane to Nashik Cab",
    description: "Thane to Nashik cab service offers dependable transportation for travelers planning comfortable road journeys to Nashik. Vehicles ensure reliable highway travel suitable for pilgrimage travel, wine tours, tourism trips, and family vacations. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Thane. Flexible booking options allow convenient Nashik cab reservations."
  },
  {
    name: "Thane to Shirdi Cab",
    description: "Thane to Shirdi cab service provides reliable transportation for travelers planning pilgrimage road journeys from Thane to Shirdi. Vehicles ensure smooth highway travel suitable for religious travel, tourism trips, and family outings. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport areas across Thane. Flexible booking options allow convenient Shirdi cab reservations."
  },
  {
    name: "Thane to Mahabaleshwar Cab",
    description: "Thane to Mahabaleshwar cab service provides comfortable transportation for travelers planning scenic hill station road journeys. Vehicles ensure reliable highway and ghat travel suitable for tourism trips, family vacations, and sightseeing tours. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Thane. Flexible booking options allow convenient Mahabaleshwar cab reservations."
  },
  {
    name: "Thane to Alibaug Cab",
    description: "Thane to Alibaug cab service offers dependable transportation for travelers planning beachside road journeys from Thane. Vehicles ensure smooth highway travel suitable for tourism travel, family vacations, beach holidays, and weekend trips. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Thane. Flexible booking options allow convenient Alibaug cab reservations."
  },
  {
    name: "Thane to Kolhapur Cab",
    description: "Thane to Kolhapur cab service provides reliable transportation for travelers planning long-distance road journeys to Kolhapur. Vehicles ensure smooth highway travel suitable for tourism travel, family holidays, business trips, and pilgrimage travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport areas across Thane. Flexible booking options allow convenient Kolhapur cab reservations."
  },
  {
    name: "Thane to Ratnagiri Cab",
    description: "Thane to Ratnagiri cab service offers comfortable transportation for travelers planning scenic Konkan road journeys from Thane. Vehicles ensure reliable highway travel suitable for tourism trips, beach holidays, family vacations, and sightseeing tours. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Thane. Flexible booking options allow convenient Ratnagiri cab reservations."
  },
  {
    name: "Thane Outstation Taxi Service",
    description: "Thane outstation taxi service provides dependable long-distance transportation for travelers planning comfortable intercity road journeys. Vehicles ensure smooth highway travel suitable for tourism travel, family holidays, pilgrimage tours, and executive journeys. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport areas across Thane. Flexible booking options allow convenient outstation taxi reservations."
  },
  {
    name: "Ghodbunder Road Cab Service",
    description: "Ghodbunder Road cab service provides reliable transportation for travelers planning comfortable local and outstation road journeys from Ghodbunder Road. Vehicles ensure smooth city and highway travel suitable for airport transfers, tourism travel, family vacations, and executive trips. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas around Ghodbunder Road Thane. Flexible booking options allow convenient cab reservations."
  }
],

tableData: [
  ["Cabs in Thane", "Thane to Pune Cab"],
  ["Cab Booking in Thane", "Cab Service in Thane"],
  ["Ertiga on Rent in Thane", "Innova Car on Rent in Thane"],
  ["Innova on Rent in Thane", "Taxi Services in Thane"],
  ["Thane Cabs", "Outstation Cab Service Thane"],
  ["Thane Airport Cab Service", "Tourist Taxi Service Thane"],
  ["Best Cab Service in Thane", "Cheap Taxi Service Thane"],
  ["Online Cab Booking Thane", "Thane Cab Fare"],
  ["Thane Taxi Fare", "24x7 Cab Service Thane"],
  ["Reliable Taxi Service Thane", "Affordable Cab Booking Thane"],
  ["Premium Cab Service Thane", "Trusted Thane Cabs"],
  ["Thane to Goa Cab", "Thane to Lonavala Cab"],
  ["Thane to Nashik Cab", "Thane to Shirdi Cab"],
  ["Thane to Mahabaleshwar Cab", "Thane to Alibaug Cab"],
  ["Thane to Kolhapur Cab", "Thane to Ratnagiri Cab"],
  ["Thane Outstation Taxi Service", "Ghodbunder Road Cab Service"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Cab Service in Thane",
    WhyChoosedescription: "Om Sai Cab Service provides reliable cab service in Thane with professional drivers, comfortable vehicles, and smooth travel for local rides, airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Affordable Thane Taxi Fare",
    WhyChoosedescription: "Our Thane taxi service offers affordable pricing with transparent fare details and no hidden charges for local travel, airport transfers, and outstation bookings."
  },
  {
    WhyChooseheading: "24/7 Thane Cab Availability",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for Thane cab bookings including airport pickups, railway station transfers, family trips, business travel, and emergency transportation."
  },
  {
    WhyChooseheading: "Comfortable & Clean AC Cabs",
    WhyChoosedescription: "All Thane taxis are fully air-conditioned, sanitized, spacious, and regularly maintained for smooth and comfortable travel experiences."
  },
  {
    WhyChooseheading: "Local & Outstation Taxi Booking Options",
    WhyChoosedescription: "Customers can book local Thane taxi service, airport transfers, one-way travel, round-trip journeys, Mumbai Darshan tours, and customized outstation travel packages."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Choices",
    WhyChoosedescription: "Om Sai Cab Service offers sedan cars, Ertiga, Innova, Innova Crysta, SUVs, luxury vehicles, and Tempo Travellers suitable for individuals, families, tourists, and corporate groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Thane",
    WhyChoosedescription: "We provide convenient pickup service from Ghodbunder Road, Majiwada, Kasarvadavali, Kalyan, Dombivli, hotels, homes, railway stations, offices, and all major Thane locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for City & Highway Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with Thane city roads, airport routes, highways, and nearby tourist destinations to ensure safe driving and timely travel."
  }
]
};

const faqData = [
  {
    question: "What is Thane cab service?",
    answer: "Thane cab service provides comfortable taxi transportation for local travel, airport transfers, sightseeing tours, and outstation journeys."
  },
  {
    question: "Is Thane cab service available 24 hours?",
    answer: "Yes, Om Sai Cab Service provides 24/7 Thane taxi service."
  },
  {
    question: "Which vehicles are available for Thane travel?",
    answer: "Customers can choose sedan taxis, Ertiga, Innova, Innova Crysta, SUVs, luxury cars, and Tempo Travellers."
  },
  {
    question: "Can I book one-way and round-trip cabs in Thane?",
    answer: "Yes, one-way as well as round-trip Thane cab bookings are available."
  },
  {
    question: "Do you provide airport pickup and drop service from Thane?",
    answer: "Yes, Om Sai Cab Service provides airport pickup and drop service for Mumbai Airport and Navi Mumbai Airport routes."
  },
  {
    question: "Are all Thane taxis air-conditioned?",
    answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel."
  },
  {
    question: "Can I book Thane cab service online?",
    answer: "Yes, customers can easily book Thane cab service online or through phone booking."
  },
  {
    question: "Do you provide cabs for family and corporate travel?",
    answer: "Yes, comfortable vehicles are available for family travel, business meetings, and corporate transportation."
  },
  {
    question: "Are Thane cab fares transparent?",
    answer: "Yes, Om Sai Cab Service provides affordable and transparent pricing without hidden charges."
  },
  {
    question: "Is advance booking available for Thane cab service?",
    answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel hours."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Patil",
    feedback: "Used Om Sai Cab Service for travel within Thane and had a very reliable experience. The cab arrived quickly and the ride was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Asha Kulkarni",
    feedback: "For cab service in Thane, Om Sai Cab Service has been very dependable. The booking was easy, the driver was polite, and the journey was hassle-free.",
    rating: 5
  }
];












    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Thane",
  "image": "http://www.omsaicabservice.com/assets/images/thane-cab-service.jpg",
  "description": "Book cab service in Thane with Om Sai Cab Service for local, airport, and outstation travel. Affordable Sedan, SUV, Ertiga, Innova, and premium taxis available for Pune, Goa, Lonavala, Nashik, and Shirdi routes with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/cab-service-in-thane"
  }
};



    return (
        <div>

<Helmet>
  <title>
    Cab Service in Thane | Local, Airport & Outstation Taxi | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book cab service in Thane for local rides, airport transfers, and outstation trips. Affordable taxi service with Sedan, SUV, Ertiga, Innova, and premium cars available 24x7 for Pune, Goa, Lonavala, Nashik, and Shirdi routes."
  />

  <meta
    name="keywords"
    content="Cabs in thane, thane to pune cab, Cab booking in thane, Cab service in thane, Ertiga on rent in thane, Innova car on rent in thane, Innova on rent in thane, taxi services in thane, Thane cabs, Outstation Cab Service Thane, Thane Airport Cab Service, Tourist Taxi Service Thane, Best Cab Service in Thane, Cheap Taxi Service Thane, Online Cab Booking Thane, Thane Cab Fare, Thane Taxi Fare, 24x7 Cab Service Thane, Reliable Taxi Service Thane, Affordable Cab Booking Thane, Premium Cab Service Thane, Trusted Thane Cabs, Thane to Pune Cab, Thane to Goa Cab, Thane to Lonavala Cab, Thane to Nashik Cab, Thane to Shirdi Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinthane;